module.exports = __webpack_public_path__ + "static/media/Ruralco LOGO_OBSESSED.6de6aeca.jpg";